import { useAppSelector } from '../../store/hooks';
import { IonSpinnerWrapper } from './RequestQueueSpinner.styles';

interface IComponentProps { }

const RequestQueueSpinner: React.FC<IComponentProps> = () => {
  const { clockingQueue, techCommentQueue, vehicleAttachmentQueue } = useAppSelector(state => state.requestQueue);

  return (
    <>
      {(clockingQueue?.length || techCommentQueue?.length || vehicleAttachmentQueue?.length) ? <IonSpinnerWrapper name="lines-small" /> : <></>}
    </>
  );
};

export default RequestQueueSpinner;
